import type { LandUpsideQuery } from '../types/feasibility';

/** The Land Upside list's query string: only what is set, in a fixed order. */
export const landUpsideParams = (q: LandUpsideQuery): string => {
  const p = new URLSearchParams();
  p.set('tab', q.tab);
  if (q.jurisdiction) p.set('jurisdiction', q.jurisdiction);
  if (q.minAcres !== undefined) p.set('minAcres', String(q.minAcres));
  if (q.family) p.set('family', q.family);
  if (q.approvals?.length) p.set('approvals', q.approvals.join(','));
  if (q.minUpsideShare !== undefined) p.set('minUpsideShare', String(q.minUpsideShare));
  if (q.page !== undefined) p.set('page', String(q.page));
  if (q.pageSize !== undefined) p.set('pageSize', String(q.pageSize));
  return p.toString();
};
